// extracted by mini-css-extract-plugin
var _1 = "TextareaSkeleton-modulehelpText__KAvHI TextareaSkeleton-moduleskeletonItem__cFkVs";
var _2 = "TextareaSkeleton-modulelabel__dBCZl TextareaSkeleton-moduleskeletonItem__cFkVs";
var _3 = "TextareaSkeleton-moduleskeletonItem__cFkVs";
var _4 = "TextareaSkeleton-moduletextarea__bonEG TextareaSkeleton-moduleskeletonItem__cFkVs";
var _5 = "TextareaSkeleton-moduletextareaSkeleton__v6Hxm";
export { _1 as "helpText", _2 as "label", _3 as "skeletonItem", _4 as "textarea", _5 as "textareaSkeleton" }
